export { default } from "./AboutOurHoney";
